import { RESET_ALL as RESET_ON_LOGOUT } from 'redux-store/reducers/common-reducer';

import { createReducer } from 'utils/redux';
import { API, get } from 'utils/api';
import { logError } from 'utils/log';
import { Querystring } from 'utils/url';
import { snakeCaseKeys } from 'utils/keys';
import { CUSTOM_LIST_TYPE } from 'utils/list';

import type { Action, Dispatch, List, ThunkAction } from 'types';

const { LISTS } = API.END_POINTS;

const LOADING = 'influencerLists/LOADING';
const LOADED = 'influencerLists/LOADED';
const RESET = 'influencerLists/RESET';

const initialState = {
  influencerLists: [],
  lists: [],
  isLoading: false
};

const ITEMS_PER_PAGE = 1000;

const listsLoaded = (lists: Array<List>): Action => ({
  type: LOADED,

  payload: {
    lists
  }
});

const loadingStateChanged = (isLoading: boolean): Action => ({
  type: LOADING,

  payload: {
    isLoading
  }
});

export const resetInfluencerLists = (): Action => ({
  type: RESET
});

export const fetchInfluencerLists = (organizationId: number, filter: string, sortBy: string): ThunkAction => async (dispatch: Dispatch) => {
  dispatch(loadingStateChanged(true));
  const params = snakeCaseKeys({
    type: CUSTOM_LIST_TYPE,
    sortBy,
    filter,
    page: 1,
    itemsPerPage: ITEMS_PER_PAGE,
    excludeMetrics: true
  });

  try {
    const queryString = Querystring.objectToString(params);
    const listsResponse = await get(`${LISTS.getLists(organizationId)}?${queryString}`);
    const lists = listsResponse.data && listsResponse.data.data || [];

    dispatch(listsLoaded(lists));
  } catch (e) {
    logError(e);
    dispatch(listsLoaded([]));
  } finally {
    dispatch(loadingStateChanged(false));
  }
};

export default createReducer<any, any>('influencerLists', initialState, {
  [RESET_ON_LOGOUT]: () => initialState,
  [RESET]: () => initialState,
  [LOADING]: (state, { isLoading }) => ({
    ...state,
    isLoading
  }),
  [LOADED]: (state, { lists }) => ({
    ...state,
    lists
  })
});
